/*** IMPORTS FROM imports-loader ***/
var global = window;

var pad = require('./pad');

module.exports = function lrpad(str, length, padStr) {
  return pad(str, length, padStr, 'both');
};

